<template>
  <svg
    class="calendar-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M7 3v3M17 3v3" />
    <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
    <path d="M3.5 9h17" />
    <path d="M8 13h.01M12 13h.01M16 13h.01M8 17h.01M12 17h.01" />
  </svg>
</template>

<script>
export default {
  name: 'CalendarIcon',
};
</script>

<style scoped>
.calendar-icon {
  display: inline-block;
  flex: 0 0 auto;
  height: 1.25em;
  vertical-align: middle;
  width: 1.25em;
}
</style>
